export default "__VITE_ASSET__9129e5cb__"